export type OptionType = {
  value: string | number;
  label: string;
};

export interface InrixTripFormData {
  outputType: number;
  startDate: string | undefined;
  endDate: string | undefined;
  fromHour: number | undefined;
  fromMinute: number | undefined;
  toHour: number | undefined;
  toMinute: number | undefined;
  showTimes: boolean | undefined;
  geoSpatialMatchOn?: OptionType[];
  includeTrajectories: boolean | undefined;
  providerTypes: OptionType[] | undefined;
  endpointTypes: OptionType[] | undefined;
  vehicleWeightClasses: OptionType[] | undefined;
}

export const geoSpatialOptions: OptionType[] = [
  {
    value: "IE",
    label: "Match when trip starts in any of the requested zones",
  },
  {
    value: "EI",
    label: "Match when trip ends in any of the requested zones",
  },
  {
    value: "EE",
    label: "Match on through trips",
  },
];

export const endpointTypeOptions: OptionType[] = [
  {
    value: -1,
    label: "Unknown",
  },
  {
    value: 0,
    label: "Trip does not start or end at a stop",
  },
  {
    value: 1,
    label: "Trip starts at a stop",
  },
  {
    value: 2,
    label: "Trip ends at a stop",
  },
  {
    value: 3,
    label: "Trip starts and ends at a stop",
  },
];

export const providerTypeOptions: OptionType[] = [
  {
    value: 1,
    label: "Consumer Vehicle",
  },
  {
    value: 2,
    label: "Fleet",
  },
];

export const vehicleWeightClassTypeOptions: OptionType[] = [
  {
    value: 1,
    label: "Light Duty Truck / Passenger Vehicle (0–14,000 lb)",
  },
  {
    value: 2,
    label: "Medium Duty Trucks / Vans (14,001–26,000 lb)",
  },
  {
    value: 3,
    label: "Heavy Duty Trucks (> 26,000 lb)",
  },
];
